import React, { useEffect, useState } from 'react';
import helpers from '@starflow/app/helpers';

export const TextEditInputInner = (props) => {
  const { element, viewport, isEditing } = props;
  const { fontSize, text, fontFamily, fontStyle } = element.data;
  const [frameSize, setFrameSize] = useState({ width: 0, height: 0 });

  const handleInputText = (event) => {
    helpers.canvas.updateElementData(element.id, {
      text: event.target.value,
    });
  };

  useEffect(() => {
    const textNode = helpers.canvas.getCanvasStage().findOne(`#${element.id}-text`);
    const { width, height } = textNode.size();
    setFrameSize({ width, height });

    helpers.canvas.updateElement(element.id, { width, height });
    helpers.canvas.updateSelectionFrame();
  }, [text, fontSize, fontFamily, fontStyle]);

  return (
    <div style={frameSize} className="absolute top-0 left-0 pointer-events-auto">
      <textarea
        value={text}
        autoFocus
        onChange={handleInputText}
        className="absolute inset-0 resize-none overflow-hidden bg-transparent whitespace-nowrap origin-top-left"
        style={{
          fontFamily: `${fontFamily}, Arial`,
          transform: `scale(${viewport.scale * element.scaleX}) rotate(${element.rotation}deg)`,
          fontSize: `${fontSize}px`,
          // 让文字变透明
          color: 'transparent',
          // 但是光标按文字颜色来显示
          caretColor: '#000',
          lineHeight: 1,
        }}
      />
    </div>
  );
};

export const TextEditInput = React.memo((props) => {
  if (!props.isEditing) return null;

  return <TextEditInputInner {...props} />;
});
